<script>
  import { showAlertModal } from '../../stores/modals.js';

  let alertModalOpened;
  showAlertModal.subscribe(value => {
		alertModalOpened = value;
	});

  function closeShowAlertModal() {
    showAlertModal.set(false);
  }
</script>

{#if alertModalOpened == true }
<div class="tw-fixed tw-bottom-0 tw-inset-x-0 tw-px-4 tw-pb-6 sm:tw-inset-0 sm:tw-p-0 sm:tw-flex sm:tw-items-center sm:tw-justify-center tw-z-50 tw-overflow-scroll">
  <div class="tw-fixed tw-inset-0 tw-transition-opacity">
    <div class="tw-absolute tw-inset-0 tw-bg-gray-500 tw-opacity-75"></div>
  </div>

  <div class="tw-bg-white tw-rounded-lg tw-px-4 tw-pt-5 tw-pb-4 tw-overflow-hidden tw-shadow-xl tw-transform tw-transition-all sm:tw-max-w-sm sm:tw-w-full sm:tw-p-6">
    <div>
      <div class="tw-mx-auto tw-flex tw-items-center tw-justify-center tw-h-12 tw-w-12 tw-rounded-full tw-bg-red-100">
        <span class="tw-text-red-600">X</span>
      </div>
      <div class="tw-mt-3 tw-text-center sm:tw-mt-5">
        <span class="tw-text-lg tw-leading-6 tw-font-medium tw-text-gray-900">
          Non disponible
        </span>
        <div class="tw-mt-2">
          <span class="tw-text-sm tw-leading-5 tw-text-gray-500">
            Cette fonctionnalité n'est pas disponible pour le moment. Nous travaillons fort pour qu'elle le soit avant le ramadant 2020.
          </span>
        </div>
      </div>
    </div>
    <div class="tw-mt-2 sm:tw-mt-4" on:click={closeShowAlertModal}>
      <span class="tw-flex tw-w-full tw-rounded-md tw-shadow-sm">
        <button type="button" class="tw-inline-flex tw-justify-center tw-w-full tw-shadow-md tw-rounded-md tw-border tw-border-transparent tw-px-4 tw-py-2 tw-bg-blue-400 tw-text-base tw-leading-6 tw-font-medium tw-text-white tw-shadow-sm hover:tw-bg-blue-300 focus:tw-outline-none focus:tw-border-blue-500 focus:tw-shadow-outline-indigo tw-transition tw-ease-in-out tw-duration-150 sm:tw-text-sm sm:tw-leading-5">
          Je donnerais pendant le ramadan inshaAllah :-)
        </button>
      </span>
    </div>
  </div>
</div>
{/if}